module.exports = __webpack_public_path__ + "img/request-tenant.83268a53.png";